import { useEffect, useState } from 'react';
import { GlobalDesignStyleGroup } from '../../types';
import { loadPanelService } from '../../../automaticPanel/panelsService';

// TODO: remove this once we have the correct type from the panel service
type GroupPreviewType = 'border' | 'borderRadius' | 'boxShadow' | 'text';

export const useGroupsPreview = (
  previewType: GroupPreviewType,
  group: GlobalDesignStyleGroup,
) => {
  const [GroupPreviewComponent, setGroupPreviewComponent] = useState<
    any | null
  >(null);

  const loadGroupComponent = async (group: GlobalDesignStyleGroup) => {
    const panelService = await loadPanelService(group.host);

    setGroupPreviewComponent(
      () => panelService.getGroupPreview({ previewType }).Component,
    );
  };

  useEffect(() => {
    if (group) {
      loadGroupComponent(group);
    }
  }, []);

  return GroupPreviewComponent;
};
